const VerticalLine = () => {
    return(
        <svg xmlns="http://www.w3.org/2000/svg" width="8" height="144" viewBox="0 0 8 144" fill="none">
  <path d="M4 4L4 140" stroke="#84BD00" strokeWidth="7" strokeLinecap="round"/>
</svg>
    )
}
export default VerticalLine;